















































import { Component, Prop, Mixins } from "vue-property-decorator";
import AdminBrandId from "@/mixins/adminBrandId";

@Component({
  components: {
    "affiliate-tiers-provider": () =>
      import(
        "@/components/app/admin/settings/affiliates/tiers/affiliateTiersProvider.vue"
      ),
    "payout-destinations-provider": () =>
      import(
        "@/components/app/global/affiliate/payoutDestinationsProvider.vue"
      ),
    "affiliate-payout-destinations-table": () =>
      import(
        "@/components/app/admin/settings/affiliates/payoutDestinations/affiliatePayoutDestinationsTable.vue"
      ),
    "affiliate-tiers-table": () =>
      import(
        "@/components/app/admin/settings/affiliates/tiers/affiliateTiersTable.vue"
      )
  }
})
export default class BrandAffiliatesSettings extends Mixins(AdminBrandId) {
  @Prop({ default: false })
  public dynamicSettingsLoading!: boolean;

  public async created() {
    this.$emit("predefinedSettingsAreLoading", false);
  }
}
